import React, { useEffect, useMemo } from 'react';
import ContentFeed from '../../ContentFeed';
import ProductCard from '../../ProductCard';

const ns = `plp-category-group`;

// category group revised matches based on shopify id so you can use products selector instead of strings
const PLPCategoryGroup = ({
	title,
	products,
	headline,
	showHr,
	location,
	onFilteredProducts,
	initialVisibleAmount = 4,
}) => {
	const modifiedTitle = title?.split(' ').join('-').toLowerCase();

	const productView = (p, index) => {
		return (
			<ProductCard
				location={location}
				// category={category}
				product={p}
				key={p.id}
				index={index}
				// hideQuickshop
				// promo={promo.value}
				// promoAmount={promoAmount}
				// hasActiveCampaign={hasActiveCampaign}
				// activeCampaign={activeCampaign}
				// campaignCopy={campaignCopy}
			/>
		);
	};

	useEffect(() => {
    if (onFilteredProducts) {
      onFilteredProducts(products);
    }
  }, [products]);

	return (
		<>
			<div className={`${ ns } container`}>
				{modifiedTitle && headline && (
					<div className={`${ ns }__heading`}>
						<h3 id={modifiedTitle} className={`${ ns }__heading-title`}>{title}</h3>
						<p className={`${ ns }__heading-description`}>{headline}</p>
					</div>
				)}
				<ContentFeed
					location={location}
					page={'category'}
					items={products}
					itemView={productView}
					initialVisibleAmount={initialVisibleAmount}
					nextVisibleAmount={0}
				/>
			</div>
			{showHr && <hr className={'main-hr'} />}
		</>
	);
};

export default PLPCategoryGroup;
